import { render } from "./add-template.vue?vue&type=template&id=f43b0e5e&ts=true"
import script from "./add-template.vue?vue&type=script&lang=ts"
export * from "./add-template.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__